import document from "../../core/chrome/document.js";

/**
 *	`externalDocument' is the common abstract superclass of all
 *	documents in External Pages. It overrides the main rendering
 *	method `that.renderContentOn`.
 */
export default document.subclass((that, my) => {
	my.initialize = function () {
		my.super(...arguments);
		my.title = undefined;
	};

	that.renderContentOn = function (html) {
		html.div(
			{ klass: "document" },
			html.div({ klass: "top" }),
			html.div(
				{ klass: "content" },
				html.div({ id: "document" }, my.renderDocumentContentOn),
			),
			html.div({ klass: "bottom" }),
		);
	};
});
